export default "/images/chevron-right.svg?d45fd2f46e93f5c3aa0a7d0617d9fecf";